const n = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase();

export function withGeral(products, categories) {
  const ids = new Set(categories.map((c) => c.id));
  const real = categories.find((c) => n(c.name) === "geral");
  const gid = real?.id || "geral";
  const out = products.map((p) => (ids.has(p.category_id) ? p : { ...p, category_id: gid }));
  const cats = !real && out.some((p) => p.category_id === gid) ? [...categories, { id: gid, name: "Geral" }] : categories;
  return { products: out, categories: cats };
}
